import React from 'react'

import { PriceWithCurrency, Tag } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { PayoutsHistoryDataItem } from '../../Billing.types'
import { tagsAppearances } from '../../consts'
import * as S from './PayoutsHistoryListItem.styled'

type PayoutHistoryListItemProps = {
  payoutHistoryItem: PayoutsHistoryDataItem
}

const getPaidToLabel = (paidTo: PayoutsHistoryDataItem['paidTo']) => {
  if (['Bank account', 'Card'].includes(paidTo)) {
    return paidTo.toLowerCase()
  }

  return paidTo
}

export const PayoutsHistoryListItem = ({ payoutHistoryItem }: PayoutHistoryListItemProps) => {
  return (
    <S.Container>
      <S.LeftSide>
        <S.Date>
          <TimezonedDateString date={payoutHistoryItem.date} format="MMM DD, YYYY" utc />
        </S.Date>
        <p>Paid to {getPaidToLabel(payoutHistoryItem.paidTo)}</p>
        <S.TagWrapper>
          <Tag
            label={payoutHistoryItem.status}
            appearance={tagsAppearances[payoutHistoryItem.status]}
          />
        </S.TagWrapper>
      </S.LeftSide>
      <S.RightSide>
        <S.PriceWrapper>
          <PriceWithCurrency {...payoutHistoryItem.transferAmount} />
        </S.PriceWrapper>
        {payoutHistoryItem.payoutAmount &&
        payoutHistoryItem.payoutAmount.currency !== payoutHistoryItem.transferAmount.currency ? (
          <S.SecondaryPriceWrapper>
            <PriceWithCurrency {...payoutHistoryItem.payoutAmount} />
          </S.SecondaryPriceWrapper>
        ) : null}
      </S.RightSide>
    </S.Container>
  )
}
